import React from "react"
import styled from "styled-components"
import {Heading} from "./Heading"
import {Flex} from "./Flex"

const Card = ({children, heading, padded, ...rest}) => {
  return (
    <OuterDiv {...rest}>
      {heading && (
        <CardHeading>
          <Flex>
            <CardTitleDiv>{heading}</CardTitleDiv>
          </Flex>
        </CardHeading>
      )}
      {children && <ChildrenDiv padded={padded}>{children}</ChildrenDiv>}
    </OuterDiv>
  )
}

const CardHeading = styled(Heading)`
  border-bottom: 1px solid ${(props) => props.theme.borderColorLight};
  padding: 0.75em ${(props) => props.theme.gutter}px;
  position: relative;
`

const CardTitleDiv = styled.div`
  flex-grow: 1;
`

const ChildrenDiv = styled.div`
  padding: ${(props) => props.padded && props.theme.gutter}px;
`

const OuterDiv = styled.div`
  background-color: white;
  box-shadow: 0 1px 3px ${(props) => props.theme.borderColorLight};
`

export {Card}
